import React from 'react';
import './SectionHeader.css';

const SectionHeader = ({ title, backgroundImage }) => {
  return (
    <div data-sal="slide-up" data-sal-duration="2000" data-sal-delay="300"
      className="section-header d-flex justify-content-center align-items-center mt-2"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <h1 className="section-title text-war">{title}</h1>



    </div>
  );
};

export default SectionHeader;
